import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReloadIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 20 18.4",
	style: { enableBackground: "new 0 0 20 18.4" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.reload-icon-st0{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "reload-icon-st0",
			d: "M14.5,6.5H19V2"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "reload-icon-st0",
			d: "M4.2,3.4C5,2.6,5.9,2,6.9,1.6S9,1,10.1,1s2.2,0.2,3.2,0.6s1.9,1,2.7,1.8l3,3.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "reload-icon-st0",
			d: "M5.5,11.9H1v4.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "reload-icon-st0",
			d: "M15.8,15c-0.8,0.8-1.7,1.4-2.7,1.8s-2.1,0.6-3.2,0.6s-2.1-0.2-3.1-0.6s-1.9-1-2.7-1.8L1,11.9"
		})
	] }) }) })]
});
export default SvgReloadIcon;
